import { type IIconsVector } from 'shared/ui'
import { type IAICallingType } from 'entities/AICalling/api/types'

export type IChipConfig<T extends string = string> = {
  id: T
  label: string
  icon: IIconsVector
  placeholder: string
}

export const TEXTING_CHIPS: IChipConfig[] = [
  {
    id: 'booking',
    label: 'Booking',
    icon: 'briefcase',
    placeholder:
      'I want an AI agent that helps customers schedule appointments and book meetings. It should check availability, collect necessary contact information, and confirm bookings via text message.',
  },
  {
    id: 'aiDataCollection',
    label: 'AI Data Collection',
    icon: 'usersCheck',
    placeholder:
      'I want an AI agent that collects customer information through SMS. It should gather details one field at a time and ensure all data is accurately captured for follow-up.',
  },
  {
    id: 'customerSupport',
    label: 'Customer Support',
    icon: 'heart',
    placeholder:
      'I want an AI agent that helps customers resolve issues and get support. It should understand the problem and escalate to a human agent when needed - all via text message.',
  },
  {
    id: 'faq',
    label: 'FAQ',
    icon: 'messageQuestion',
    placeholder:
      'I want an AI agent that answers customer questions via text. It should respond using a knowledge base and escalate to a human agent when the issue is beyond its scope.',
  },
]

export const CALLING_CHIPS: IChipConfig<IAICallingType>[] = [
  {
    id: 'faq_information',
    label: 'FAQ',
    icon: 'messageQuestion',
    placeholder:
      'I want an AI agent that answers customer questions over the phone. It should respond using a knowledge base and escalate to a human agent when the issue is beyond its scope.',
  },
  {
    id: 'take_message',
    label: 'Take message',
    icon: 'voicemail',
    placeholder:
      'I want an AI agent that captures caller details and their message over the phone. It should collect the necessary information accurately and ensure it is logged for follow-up.',
  },
]
